import request from '@/utils/request'

// 查询部门列表
export function listDept(query) {
  return request({
    url: '/admi/dept/list',
    method: 'get',
    params: query
  })
}
// 查询部门列表
export function deptTreeselect() {
  return request({
    url: '/admi/dept/optionTreeselect',
    method: 'get'
  })
}

// 查询部门列表（排除节点）
export function listDeptExcludeChild(deptId) {
  return request({
    url: '/admi/dept/list/exclude/' + deptId,
    method: 'get'
  })
}

// 查询部门详细
export function getDept(deptId) {
  return request({
    url: '/admi/dept/' + deptId,
    method: 'get'
  })
}

// 查询第三级及以下部门列表
export function deptOptionThreeTree(level) {
  return request({
    url: '/admi/dept/selectDeptOptionThreeTree/' + level,
    method: 'get'
  })
}

// 查询部门下拉树结构
export function treeselect() {
  return request({
    url: '/admi/dept/treeselect',
    method: 'get'
  })
}

// vant 级联选择
export function CascaderTreeSelect() {
  return request({
    url: '/admi/dept/CascaderTreeSelect',
    method: 'get'
  })
}

// 根据角色ID查询部门树结构
export function roleDeptTreeselect(roleId) {
  return request({
    url: '/admi/dept/roleDeptTreeselect/' + roleId,
    method: 'get'
  })
}

// 新增部门
export function addDept(data) {
  return request({
    url: '/admi/dept',
    method: 'post',
    data: data
  })
}

// 修改部门
export function updateDept(data) {
  return request({
    url: '/admi/dept',
    method: 'put',
    data: data
  })
}

// 删除部门
export function delDept(deptId) {
  return request({
    url: '/admi/dept/' + deptId,
    method: 'delete'
  })
}

// 同步企业微信部门
export function syncQyWxDept() {
  return request({
    url: '/admi/dept/syncQyWxAdd',
    method: 'post'
  })
}

// 查询业务类型列表
export function businessTypeList(query) {
  return request({
    url: '/scrm/businesstype/list',
    method: 'get',
    params: { ...query, status: 0 }
  })
}
// 新增商机时查询业务类型列表
export function selectAllAddBo(query) {
  return request({
    url: '/scrm/businesstype/selectAllAddBo',
    method: 'get',
    params: { ...query, status: 0 }
  })
}

// 查询行业分类列表
export function advIndustryPointList(query) {
  return request({
    url: '/cont/advIndustryPoint/list',
    method: 'get',
    params: query
  })
}

// 查询公司列表
export function companyList(query) {
  return request({
    url: '/system/company/list',
    method: 'get',
    params: query
  })
}
// 根据业务类型匹配公司
export function listAddContract(query) {
  return request({
    url: '/system/company/listAddContract',
    method: 'get',
    params: query
  })
}
// 根据业务类型匹配媒体产品
export function listAllBusinessTypeMedia(query) {
  return request({
    url: '/scrm/businessTypeMedia/listAll',
    method: 'get',
    params: query
  })
}
